// src/components/layout/AdminLayout.tsx - Add SearchToolbar below nav
import React from 'react';
import { Outlet } from 'react-router-dom';
import { Container, Box } from '@mui/material';
import AdminTopNav from '../navigation/AdminTopNav';
import Footer from '../Footer';
import QuickIdeaButton from '../ideas/QuickIdeaButton';
import SearchToolbar from '../SearchToolbar';
import SearchModal from '../SearchModal';
import { useGlobalSearch } from '../../hooks/useGlobalSearch';

const AdminLayout: React.FC = () => {
  const { isOpen, openSearch, closeSearch } = useGlobalSearch();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AdminTopNav />
      <SearchToolbar onResultClick={closeSearch} onSearchOpen={openSearch} />
      <Container component="main" sx={{ flexGrow: 1, mt: 4, mb: 4 }}>
        <Outlet />
        <QuickIdeaButton />
      </Container>
      <Footer />
      <SearchModal open={isOpen} onClose={closeSearch} />
    </Box>
  );
};

export default AdminLayout;